module.exports = __webpack_public_path__ + "media/images/smart_phone/icons/indicater_bg-67db9585bd24c5a27469de26f4861cb7.png";